"use client";
// Imports
import { formatEventTimeLabel, formatShowCalendarDayLabel } from "@/lib/showDates";

export function EventTimesTable({
  collectionHandle,
  eventTimes,
  everyDay,
  selectedDay,
}) {
  if (collectionHandle !== "events") return null;

  return (
    <div className="overflow-y-auto bg-white border-2 border-gray-300 rounded-md shadow-md max-h-64">
      <table className="w-full h-12 bg-white border-collapse table-auto">
        <thead className="sticky top-0 z-10 bg-white border-b-2">
          <tr className="">
            <th className="p-2 text-left border-b border-gray-300">Date</th>
            <th className="p-2 text-left border-b border-gray-300">
              Start Time
            </th>
            <th className="p-2 text-left border-b border-gray-300">End Time</th>
          </tr>
        </thead>
        <tbody>
          {eventTimes.map((eventTime, index) => {
            const dateString = formatShowCalendarDayLabel(eventTime?.date);
            const startTime = formatEventTimeLabel(eventTime?.start_time, {
              allDay: Boolean(eventTime?.all_day),
            });
            const endTime = formatEventTimeLabel(eventTime?.end_time, {
              allDay: Boolean(eventTime?.all_day),
            });

            return (
              <tr key={index} className="hover:bg-gray-50">
                <td className="p-2 border-b border-gray-300">{dateString}</td>
                <td className="p-2 border-b border-gray-300">{startTime}</td>
                <td className="p-2 border-b border-gray-300">
                  {eventTime?.showEndTime && eventTime?.end_time
                    ? endTime
                    : "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
